import { Button } from '@heathmont/moon-components';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import Translate from '~/client/shared/i18n/Translate';
import useAccountPopoverStore from '~/client/store/useAccountPopoverStore';
import AuthenticateView from './AuthenticateView';

type Props = {
  isRegister?: boolean;
};

const AuthenticatePopover: FC<Props> = ({ isRegister }) => {
  const { dismissPopover } = useAccountPopoverStore();
  const { game } = useGameContext();
  const handlePlayForFun = () => {
    dismissPopover(true);
  };
  const showPlayForFunButton = !isRegister && game?.hasFunMode;

  return (
    <>
      <AuthenticateView isRegister={isRegister} />
      {showPlayForFunButton && (
        <Button variant="secondary" onClick={handlePlayForFun} fullWidth>
          <Translate id="game.play_for_fun" />
        </Button>
      )}
    </>
  );
};
export default AuthenticatePopover;
